import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'confirm',
        path: `${AUTH_PREFIX_PATH}/confirm`,
        component: React.lazy(() => import('views/auth-views/authentication/confirm')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboardMenu',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/clients/dashboards/default')),
    },

    {
        key: 'clients.profile',
        path: `${APP_PREFIX_PATH}/client/profile/*`,
        component: React.lazy(() => import('views/app-views/clients/profile')),
        exact: true,
    },   
    {
        key: 'accounts.investment-accounts',
        path: `${APP_PREFIX_PATH}/accounts/*`,
        component: React.lazy(() => import('views/app-views/clients/accounts')),
    },
    {
        key: 'walletMenu',
        path: `${APP_PREFIX_PATH}/financial/*`,
        component: React.lazy(() => import('views/app-views/clients/financial')),
        exact: true,
    },    
    {
        key: 'support.tickets',
        path: `${APP_PREFIX_PATH}/support/tickets`,
        component: React.lazy(() => import('views/app-views/clients/support/tickets')),
    },
    {
        key: 'support.tickets.view',
        path: `${APP_PREFIX_PATH}/support/ticket/:ticket_id`,
        component: React.lazy(() => import('views/app-views/clients/support/tickets/view')),
    },
    {
        key: 'support.platform',
        path: `${APP_PREFIX_PATH}/support/platform`,
        component: React.lazy(() => import('views/app-views/clients/support/platform')),
    },
    {
        key: 'support.faq',
        path: `${APP_PREFIX_PATH}/support/faq`,
        component: React.lazy(() => import('views/app-views/clients/support/faq')),
    }
    
]